import PropTypes from 'prop-types';

const propTypes = {
  ...PropTypes
};

export default propTypes;
